export const propertyId = "covenanter-hill";